import React from 'react';
import ReactDOM from 'react-dom';

import Menu from './menu';

import Store from '@app/store';
import I18n from '@module/i18n';
import Accordion from '@component/accordion';
import ActionBar from '@component/info/actionbar';
import Button from '@component/form/element/button';
import StaticPage from '@component/panel/content';
import VerticalNav from '@component/navigation/verticalnav';

let previousContext = null;
const { user, route } = Store.getState();
const ctaCancel = I18n.t('page.transfer_progress.upsell.button.cancel');
const cta = I18n.t('transfer.buttons.cancel_yes');
const text = I18n.t('page.about.legal.actionbar.text');

let closeBar = null;
const clearCookies = () => {
  location.assign('/cookies/clear');
};

export const renderBar = (props) => {
  const actionBarContainer = document.querySelector('.actionbar__container');
  ReactDOM.render(
    <ActionBar text={text} hidden={props.hidden}>
      <Button type="actionbar-action" text={cta} onClick={clearCookies} />
      <Button type="actionbar-cancel" text={ctaCancel} onClick={closeBar} />
    </ActionBar>,
    actionBarContainer
  );
};

closeBar = () => renderBar({ hidden: true });
const openBar = () => renderBar({ hidden: false });

const renderContent = (instance) => {
  // selecting sections to convert to dropdowns
  const sections = instance.node.querySelectorAll('.expandable');
  const items = Array.from(sections).map((section) => ({
    title: section.querySelector('h2'),
    content: section,
  }));

  // creating dropdowns through accordion
  const accordionContainer = instance.node.querySelector(
    '.legal__content-expandables'
  );
  if (items.length > 0) {
    ReactDOM.render(<Accordion items={items} />, accordionContainer);
  }
};

export const callback = (instance) => {
  // We want to be updated with store updates
  instance.subscribeToStore = true;

  // Render vertical menu
  const navElement = instance.node.querySelector('#legal__nav');

  // Render privacy and cookie page with accordion
  if (instance.path === '/legal/privacy') {
    renderContent(instance);
    const clearCookieBtn = instance.node.querySelector('.contentbox__action');
    const contentbox = instance.node.querySelector('.contentbox__notice');

    if (user.loggedIn) {
      contentbox.innerHTML = I18n.t('cookiebox.notice');
    }

    clearCookieBtn.addEventListener('click', openBar);
  }

  ReactDOM.render(
    <VerticalNav items={Menu} activeItem={instance.path} />,
    navElement
  );

  if (previousContext === null && route.context) {
    previousContext = route.context;
  }

  // check if user is coming from legal links on welcome page
  const paramName = 'from_home';
  const params = new URLSearchParams(document.location.search);
  const isFromWelcomeLink = params.has(paramName);
  // show back button if user clicked on legal links from welcome page experiment
  if (isFromWelcomeLink) {
    instance.setReturnPath('/', I18n.t('site.name'));
    // clean up search params
    params.delete(paramName);
  }

  // Show 'return path' only for certain pages
  if (instance.setReturnPath) {
    switch (previousContext) {
      case 'plus':
        instance.setReturnPath(
          '/pro',
          I18n.t('navigation.about_us.items.plus')
        );
        break;
      case 'about':
        instance.setReturnPath('/about', I18n.t('navigation.about_us.name'));
        break;
    }
  }

  // When we navigate away from the page, cleanup listeners
  instance.onCleanup = () => {
    ReactDOM.unmountComponentAtNode(navElement);

    const { route } = Store.getState();
    // Since navigating out of the legal pages
    if (!route.path.match('legal')) {
      previousContext = null;
    }
  };
};

StaticPage.configure('/legal/terms', callback);
StaticPage.configure('/legal/privacy', callback);
StaticPage.configure('/legal/takedown', callback);
StaticPage.configure('/legal/disclosure', callback);
StaticPage.configure('/legal/advertising', callback);
